module.exports = __webpack_public_path__ + "media/question1_au.69478b41.mp3";